import React, { useMemo } from 'react';
import { createTheme, GlobalStyle } from '@hiro-ui/bootstrap';
import { ThemeProvider } from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';

import { SiteThemeQuery } from '../../graphql-types';

export const RootWrapper = ({ children }) => {
  const data = useStaticQuery<SiteThemeQuery>(graphql`
    query SiteTheme {
      site {
        siteMetadata {
          theme
        }
      }
    }
  `);

  const theme = useMemo(
    () =>
      createTheme({
        colors: {
          primary: data.site.siteMetadata.theme,
        },
        sizes: {
          borderRadius: '0.5rem',
        },
        breakpoints: {
          xl: 1400,
        },
        greyscale: {
          lighter: '#fdfdfd',
        },
        global: {
          fontSize: '16px',
          fontFamily: "'Titillium Web', sans-serif",
          padding: '0',
          wordWrap: 'break-word',

          button: {
            fontSize: '16px',
            fontFamily: "'Titillium Web', sans-serif",
          },

          h4: {
            fontSize: '16px',
            fontWeight: 400,
            color: data.site.siteMetadata.theme,
            margin: '1em 0 0.5em 0',
          },
        },
        font: {
          h1: {
            fontSize: '24px',
            fontWeight: 400,
          },
          h2: {
            fontSize: '20px',
            fontWeight: 400,
            color: data.site.siteMetadata.theme,
            margin: '2em 0 1.5em 0',
          },
          h3: {
            fontSize: '18px',
            fontWeight: 400,
            color: data.site.siteMetadata.theme,
            margin: '1.5em 0 1em 0',
          },
        },
      }),
    [data],
  );

  // props provide same data to Layout as Page element will get
  // including location, data, etc - you don't need to pass it
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle theme={theme} />
      {children}
    </ThemeProvider>
  );
};

export default RootWrapper;
